import Button from '@ui-kit/components/button';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { BaseGameState } from '@base/features/game/model/interfaces';
import React, { useState } from 'react';
import { ReactComponent as LightningIcon } from '@ui-kit/icons/lightning.svg';
import { GameButton } from '@base/features/game/model/interfaces';
import InvitePlayersModal from '../invitePlayersModal';

export type GameButtons = Partial<Record<GameButton, JSX.Element>>;

export default function BaseGameButtons(props: { gameState: BaseGameState, children: GameButtons}) {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const gameButtons = useBehaviorSubject(props.gameState.onGameButtonsChanged);

  const buttons: GameButtons = {
    [GameButton.INVITE]: (
      <>
        <Button onClick={() => setShowInviteModal(true)}>{t('invite_players')}</Button>
        {showInviteModal && <InvitePlayersModal closeModal={() => setShowInviteModal(false)} />}
      </>
    ),
    [GameButton.CONTINUE]: <Button onClick={() => props.gameState.continueClick()}>{t('continue')}</Button>,
    [GameButton.START]: (
      <Button icon={<LightningIcon />} onClick={() => props.gameState.startClick()}>
        {t('start')}
      </Button>
    ),
    [GameButton.NEW_GAME]: (
      <Button onClick={() => props.gameState.newGameClick()} icon={<LightningIcon />}>
        {t('new_game')}
      </Button>
    ),
    ...props.children
  };

  return (
    <>
      {gameButtons.map((button) => (
        <React.Fragment key={button}>{buttons[button]}</React.Fragment>
      ))}
    </>
  );
}
